import {styled} from '../styled'

export const LogoCivitime = styled('img')({
    width: '100px',
})